import React, { ReactNode, useState } from "react";
import { useNavigate } from "react-router";
import Button from "components/button/button";
import "./progress-dots.css";

interface GlimpseProgressDotsProps {
  totalSlides: number;
  children: ReactNode;
  isVertical?: boolean;
  currentSlide: number;
  enableNext?: boolean;
  onNext: (isQuiz: boolean) => void;
  handleSortNow: () => void;
  handleFinish: () => void;
  onPrev: () => void;
  onClose?: () => void;
  enableQuiz: boolean;
  enableSorting?: boolean;
  isQuiz?: boolean;
  maxHeight?: boolean;
  hideButtons?: boolean;
}

const GlimpseProgressDots: React.FC<GlimpseProgressDotsProps> = ({
  totalSlides,
  children,
  isVertical,
  currentSlide,
  enableNext,
  onNext,
  handleSortNow,
  onPrev,
  onClose,
  enableQuiz,
  handleFinish,
  enableSorting,
  isQuiz,
  maxHeight = false,
  hideButtons = false,
}) => {
  const navigate = useNavigate();

  const handleNext = (isQuiz: boolean = false) => {
    onNext(isQuiz);
  };

  const handlePrev = () => {
    onPrev();
  };

  const renderDots = () => {
    const dots: JSX.Element[] = [];

    for (let i = 1; i <= totalSlides; i++) {
      dots.push(
        <div
          key={i}
          className={`rounded-full ${
            currentSlide === i
              ? `bg-action ${
                  isVertical ? "h-[16px] w-[6px]" : "w-[16px] h-[6px]"
                }`
              : `bg-border ${
                  isVertical ? "" : ""
                } h-[6px] w-[6px]`
          }`}
        />
      );
    }

    return dots;
  };

  return (
    <>
      <div className="w-full flex flex-col h-full">
        <div className="flex flex-col flex-1 min-h-0">
          {!isVertical && (
            <div
              className={
                !maxHeight
                  ? `flex-1 lg:min-h-[416px] h-full`
                  : "flex-1"
              }
            >
              {children}
            </div>
          )}
        </div>
        {hideButtons ? null : isVertical ? (
          <div className="flex justify-center ">
            <div className="flex flex-col items-center justify-center pr-5 sm:px-5 relative left-0 sm:left-[15%]">
              {renderDots()}
            </div>
            <div className="flex flex-col items-center">{children}</div>
          </div>
        ) : (
          <>
            {currentSlide === totalSlides && !isQuiz ? (
              <>
                <div className="flex items-center justify-between h-[40px] mt-8">
                  {currentSlide <= 1 && onClose ? (
                    <Button
                      variant="secondary"
                      onClick={onClose}
                    >
                      Close
                    </Button>
                  ) : (
                    <Button
                      variant="secondary"
                      onClick={handlePrev}
                      className={currentSlide <= 1 ? "invisible" : ""}
                    >
                      Back
                    </Button>
                  )}
                  <Button
                    variant="primary"
                    onClick={
                      !enableQuiz ? handleFinish : () => handleNext(true)
                    }
                    disabled={!enableNext}
                  >
                    {!enableQuiz ? `Finish` : `Start Quiz`}
                  </Button>
                </div>
              </>
            ) : (
              <div
                className={`flex relative items-center justify-between h-[40px] mt-8`}
              >
                {currentSlide <= 1 && !isQuiz && onClose ? (
                  <Button
                    variant="secondary"
                    onClick={onClose}
                  >
                    Close
                  </Button>
                ) : (
                  <Button
                    variant="secondary"
                    onClick={handlePrev}
                    className={currentSlide <= 1 ? "invisible" : ""}
                  >
                    Back
                  </Button>
                )}

                <div className="render-dots">
                  {renderDots()}
                </div>
                {enableSorting && (
                  <Button
                    variant="primary"
                    disabled={!enableNext}
                    onClick={handleSortNow}
                  >
                    Sort Now
                  </Button>
                )}
                <Button
                  variant="primary"
                  disabled={!enableNext}
                  onClick={() => {
                    if (isQuiz && currentSlide === totalSlides) {
                      handleFinish();
                    } else {
                      handleNext(false);
                    }
                  }}
                >
                  {isQuiz && currentSlide === totalSlides ? "Finish" : "Next"}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default GlimpseProgressDots;
